const getters = {
    GET_COUNTRIES: (state) => state.countries,
    GET_COUNTRY_LOAD_STATE: (state) => state.loading_countries,
    GET_ACTIVE_COUNTRY: (state) => state.active_country,
}

export default getters
